const labels = {
  QrCode: {
    'Ref: Page title': 'Ref: Page title',
    'Ref: Hi': 'Ref: Hi',
    'Ref: Page content body': 'Ref: Page content body',
  },
};
export default labels;
